import { render } from "./MerchantForm.vue?vue&type=template&id=00d9472f&scoped=true"
import script from "./MerchantForm.vue?vue&type=script&lang=js"
export * from "./MerchantForm.vue?vue&type=script&lang=js"

import "./MerchantForm.vue?vue&type=style&index=0&id=00d9472f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00d9472f"]])

export default __exports__